import { Comment } from "react-loader-spinner";
import "./App.css";
import gptLogo from "./assets/mit.png";
import addBtn from "./assets/add-30.png";
import home from "./assets/home.svg";
import saved from "./assets/bookmark.svg";
import rocket from "./assets/rocket.svg";
import sendBtn from "./assets/send.svg";
import userIcon from "./assets/avatar.png";
import gptImgLogo from "./assets/tim2.png";
import hydrant from "./assets/hydrant.png";
import mapIcon from "./assets/map.png";
import foodIcon from "./assets/food.png";
import { useRef, useState, useEffect } from "react";
import { sendMsgToOpenAI } from "./openai";

function App() {
  const msgEnd = useRef(null);

  const [loading, setLoading] = useState(false);

  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content:
        "Hi, I am ChatMIT. A state-of-the-art language model trained on real-time MIT data to help students just like you! How can I help?",
    },
  ]);

  useEffect(() => {
    msgEnd.current.scrollIntoView();
  }, [messages]);

  const handleSend = async () => {
    const text = input;
    setInput("");
    setMessages([...messages, { role: "user", content: text }]);
    setLoading(true);
    const res = await sendMsgToOpenAI([
      ...messages,
      { role: "user", content: text },
    ]);
    setLoading(false);
    setMessages([
      ...messages,
      { role: "user", content: text },
      { role: "assistant", content: res.content },
    ]);
  };

  const handleEnter = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      await handleSend();
    }
  };

  function redirectToHydrant() {
    window.location.href = "https://hydrant.mit.edu/";
  }

  function redirectToMaps() {
    window.location.href = "https://whereis.mit.edu/";
  }

  function redirectToDining() {
    window.location.href = "https://studentlife.mit.edu/dining";
  }

  return (
    <div className="App">
      <div className="sideBar">
        <div className="upperSide">
          <div className="upperSideTop">
            <img src={gptLogo} alt="Logo" className="logo" />
            <span className="brand">ChatMIT</span>
          </div>
          <button
            className="midBtn"
            onClick={() => {
              window.location.reload();
            }}
          >
            <img src={addBtn} alt="new chat" className="addBtn" />
            New Chat
          </button>
          <div className="upperSideBottom">
            <button onClick={redirectToHydrant} className="query">
              <img src={hydrant} alt="Query" />
              Hydrant
            </button>
            <button className="query" onClick={redirectToMaps}>
              <img src={mapIcon} alt="Query" />
              Map of MIT
            </button>
            <button className="query" onClick={redirectToDining}>
              <img src={foodIcon} alt="Query" />
              MIT Dining
            </button>
          </div>
        </div>
        <div className="lowerSide">
          <div className="listItems">
            <img src={home} alt="Home" className="listItemsImg" />
            Home
          </div>
          <div className="listItems">
            <img src={saved} alt="Saved" className="listItemsImg" />
            Saved
          </div>
          <div className="listItems">
            <img src={rocket} alt="Upgrade" className="listItemsImg" />
            Upgrade to Pro
          </div>
        </div>
      </div>
      <div className="main">
        <div className="chats">
          {messages.map((message, i) => (
            <div
              key={i}
              className={message.role === "assistant" ? "chat bot" : "chat"}
            >
              <img
                className="chatImg"
                src={message.role === "assistant" ? gptImgLogo : userIcon}
                alt=""
              />
              <p className="txt">{message.content}</p>
            </div>
          ))}
          {loading && (
            <Comment
              visible={true}
              height="70"
              width="70"
              ariaLabel="comment-loading"
              wrapperStyle={{
                float: "right", // Set float to right
              }}
              wrapperClass="comment-wrapper"
              color="#fff"
              backgroundColor="#A31F34"
            />
          )}
          <div ref={msgEnd} />
        </div>
        <div className="chatFooter">
          <div className="inp">
            <input
              type="text"
              placeholder="Send a message"
              value={input}
              onKeyDown={handleEnter}
              onChange={(e) => {
                setInput(e.target.value);
              }}
            />
            <button className="send" onClick={handleSend}>
              <img src={sendBtn} alt="Send" />
            </button>
          </div>
          <p>
            ChatMIT may produce inaccurate information about people, places, or
            facts. ChatMIT HackMIT Version.
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
